import { memo, useEffect } from 'react';
import { isAiWidgetTeam25Enabled, isAiWidgetSameOriginScriptSrcEnabled } from '@helpcenter/feature-flags';
import { getMeta } from '@helpcenter/meta';
import { di } from 'react-magnetic-di';
import { getEnv, EnvType } from '@atlassian/help-center-common-util/env';

export { CSMSupportWidgetConfigProvider, CSMSupportSiteAiSearchTrigger, CSMSupportAgent, withAiAgent } from './ui';

export const CsmChatWidget = memo(function CsmChatWidget() {
    di(getEnv, getMeta, isAiWidgetTeam25Enabled, isAiWidgetSameOriginScriptSrcEnabled);

    useEffect(() => {
        if (!isAiWidgetTeam25Enabled()) {
            return undefined;
        }

        const site = window.location.hostname;

        const src = isAiWidgetSameOriginScriptSrcEnabled()
            ? new URL(`https://${site}/csm/widget/script.js`)
            : new URL(
                  getEnv().environment === EnvType.PROD
                      ? 'https://jcs-chat-widget.atlassian.com/script.js'
                      : 'https://jcs-chat-widget.stg.atlassian.com/script.js'
              );
        src.searchParams.set('siteId', getMeta('tenant-id') || '');
        src.searchParams.set('site', site);

        const script = document.createElement('script');
        script.async = true;
        script.src = src.toString();
        script.setAttribute('data-testid', 'csm-chat-widget-script');

        const body = document.querySelector('body');
        body?.appendChild(script);

        return () => {
            body?.removeChild(script);
        };
    }, []);

    return null;
});
